import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import _ from 'lodash';

@Pipe({
   name: 'safeStyle',
})
export class SafeStylePipe implements PipeTransform {
   constructor(private sanitizer: DomSanitizer) {}

   transform(value: string): SafeHtml {
      if (_.isNil(value)) {
         value = '';
      }
      return this.sanitizer.bypassSecurityTrustStyle(value);
   }
}
